import { createAction } from 'redux-actions';

export const FETCHED_NEWSLETTER_USERS = 'FETCHED_NEWSLETTER_USERS';

export const fetchedNewsletterUsers = createAction(FETCHED_NEWSLETTER_USERS, data => data);
